import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  LabelModule,
  IconModule,
  LoaderModule,
  SelectModule,
  FormFeedbackModule,
  TextInputModule
} from '@liberty-financial/ng-components';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { PipesModule } from '@shared/pipes/pipes.module';

import { SparkClearableTextInputComponent } from './searchText/clearable-text-input.component';
import { SparkSharedFormTypeaheadFieldComponent } from './typeahead/typeahead-field.component';
import { TypeaheadFieldComponent } from './typeahead-field/typeahead-field.component';
import { SparkNonResettableYesNoBothFieldComponent } from './yes-no-both-field/non-resettable-yes-no-both.component';
import { YesOrNoFieldComponent } from './yes-or-no-field/yes-or-no.component';

@NgModule({
  declarations: [
    TypeaheadFieldComponent,
    YesOrNoFieldComponent,
    SparkSharedFormTypeaheadFieldComponent,
    SparkNonResettableYesNoBothFieldComponent,
    SparkClearableTextInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LabelModule,
    IconModule,
    LoaderModule,
    TypeaheadModule.forRoot(),
    SelectModule,
    PipesModule,
    FormFeedbackModule,
    TextInputModule
  ],
  exports: [
    TypeaheadFieldComponent,
    YesOrNoFieldComponent,
    SparkSharedFormTypeaheadFieldComponent,
    SparkNonResettableYesNoBothFieldComponent,
    SparkClearableTextInputComponent
  ]
})
export class FormFieldsModule {}
